import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'tr-wrapper-two-columns' ,
    templateUrl: './tr-wrapper-two-columns.component.html',
    styleUrls: [ './tr-wrapper-two-columns.component.scss' ],
    encapsulation: ViewEncapsulation.None,
})
export class TrWrapperTwoColumnsComponent {

    @Input() public bgColor: string;
    public url: SafeResourceUrl = '';

    @Input('backgroundImage') public set backgroundImage(value: any) {
        if ( value && typeof value !== 'string' ) {
            this.url = this.utils.isMobile() ? value[1] : value[0];
        } else {
            this.url = value;
        }
    }
    constructor(
        private utils: UtilitiesService,
        private sanitizer: DomSanitizer,
    ) { }
}
